import { FunctionComponent } from 'react';
import SkillsGrid from './SkillsGrid';
import { BeakerIcon } from '@heroicons/react/outline';
import { serialize } from '../../utilities/richText';
import { RichTextNode } from '../../lib/staticResume';

type ExperienceProps = {
  experience?: {
    id: string;
    title: string;
    company: string;
    duration: string;
    skills: string;
    description: RichTextNode[];
  }[];
};

const Experience: FunctionComponent<ExperienceProps> = ({ experience }) => {
  return (
    <div className="flow-root mt-12" id="experience">
      <h2 className="mb-6 text-xl font-bold text-friendly-pink">
        Work experience
      </h2>
      <ul role="list" className="-mb-8">
        {experience &&
          experience.map((exp, index) => {
            return (
              <li key={exp.id}>
                <div className="relative pb-12">
                  {index !== experience.length - 1 ? (
                    <span
                      className="absolute top-3 left-3 -ml-px h-full w-0.5 bg-techy-green"
                      aria-hidden="true"
                    />
                  ) : null}
                  <div className="relative flex items-start space-x-3">
                    <div className="relative">
                      <BeakerIcon className="box-content w-6 h-6 py-2 bg-royalty-blue text-techy-green" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div>
                        <div className="text-sm">
                          <p className="font-bold text-egg">{exp.title}</p>
                        </div>
                        <p className="mt-0.5 text-sm text-egg font-semibold">
                          {exp.company}
                        </p>
                        <p className="mt-0.5 text-sm text-egg">
                          {exp.duration}
                        </p>
                      </div>
                      <div className="mt-0.5 -ml-1">
                        <SkillsGrid skills={exp.skills} />
                      </div>
                      <div className="mt-2 text-sm text-egg">
                        {Array.isArray(exp.description) &&
                          serialize(exp.description)}
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default Experience;
